// extracted by mini-css-extract-plugin
export default {"cardBlock":"CardBlock_cardBlock__CMJvn","grey":"CardBlock_grey__oRP89","white":"CardBlock_white__wW0SS","textContainer":"CardBlock_textContainer__Nqnke"};